import type { ReactNode } from 'react';
import {
  defaultRenderStep,
  type IntakeShellRenderProps,
} from './IntakeShell.js';
import { Step1BusinessBasics } from './Step1BusinessBasics.js';
import { Step2BrandKit } from './Step2BrandKit.js';
import { Step3StripeConnect } from './Step3StripeConnect.js';
import { Step4Payments } from './Step4Payments.js';
import { Step5StaffRoster } from './Step5StaffRoster.js';
import { Step6Domain } from './Step6Domain.js';
import { Step7ServiceCatalog } from './Step7ServiceCatalog.js';
import { Step8Modules } from './Step8Modules.js';
import { Step9DataMigration } from './Step9DataMigration.js';
import { Step10Review } from './Step10Review.js';

/**
 * wd-2.3.2 — Dispatches the current intake step id to the matching
 * step component. Steps that haven't been implemented yet fall through
 * to the shell's default placeholder so the chrome keeps working while
 * the remaining D2.3.x tickets land.
 */
export function renderIntakeStep(props: IntakeShellRenderProps): ReactNode {
  switch (props.stepId) {
    case '1':
      return <Step1BusinessBasics {...props} />;
    case '2':
      return <Step2BrandKit {...props} />;
    case '3':
      return <Step3StripeConnect {...props} />;
    case '4':
      return <Step4Payments {...props} />;
    case '5':
      return <Step5StaffRoster {...props} />;
    case '6':
      return <Step6Domain {...props} />;
    case '7':
      return <Step7ServiceCatalog {...props} />;
    case '8':
      return <Step8Modules {...props} />;
    case '9':
      return <Step9DataMigration {...props} />;
    case '10':
      return <Step10Review {...props} />;
    default:
      return defaultRenderStep(props);
  }
}
